import { Component, Input, OnChanges } from "@angular/core";

export interface TransitionRow {
  label: string;
  from: number;
  to: number;
}

@Component({
  selector: "app-exp-transition-map",
  standalone: true,
  imports: [],
  template: `
    <div class="transition-map">
      <div class="tm-row header">
        <div></div>
        <div>From</div>
        <div></div>
        <div>To</div>
        <div>Delta</div>
      </div>
      @for (r of rendered; track r) {
        <div class="tm-row">
          <div class="tm-label">{{ r.label }}</div>
          <div class="mono">{{ format(r.from) }}</div>
          <div class="tm-arrow">
            <div class="track">
              <div class="from" [style.width.%]="r.fromPct"></div>
              <div class="to" [style.width.%]="r.toPct"></div>
            </div>
          </div>
          <div class="mono">{{ format(r.to) }}</div>
          <div class="mono" [class.pos]="r.delta > 0" [class.neg]="r.delta < 0">
            {{ r.deltaDisplay }}
          </div>
        </div>
      }
    </div>
  `,
  styles: [
    `
      .tm-row {
        display: grid;
        grid-template-columns: 120px 56px 1fr 56px 64px;
        gap: 10px;
        padding: 6px 0;
        align-items: center;
        font-size: 12px;
      }
      .tm-row.header > div {
        color: var(--text-dim);
        font-size: 10.5px;
        text-transform: uppercase;
        letter-spacing: 0.05em;
      }
      .tm-arrow .track {
        height: 10px;
        background: var(--surface-2);
        border-radius: 4px;
        position: relative;
        overflow: hidden;
      }
      .tm-arrow .from {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        background: rgba(138, 144, 163, 0.55);
        border-radius: 4px;
      }
      .tm-arrow .to {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        background: linear-gradient(90deg, #7c5cff, #a78bff);
        border-radius: 4px;
      }
      .tm-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    `,
  ],
})
export class TransitionMapComponent implements OnChanges {
  @Input() rows: TransitionRow[] = [];
  @Input() format: (v: number) => string = (v) => (v * 100).toFixed(1) + "%";

  rendered: Array<
    TransitionRow & {
      fromPct: number;
      toPct: number;
      delta: number;
      deltaDisplay: string;
    }
  > = [];

  ngOnChanges(): void {
    const max = Math.max(
      ...this.rows.map((r) => Math.max(Math.abs(r.from), Math.abs(r.to))),
      0.0001,
    );
    this.rendered = this.rows.map((r) => {
      const delta = r.to - r.from;
      return {
        ...r,
        fromPct: Math.min(100, (Math.abs(r.from) / max) * 100),
        toPct: Math.min(100, (Math.abs(r.to) / max) * 100),
        delta,
        deltaDisplay: (delta > 0 ? "+" : "") + (delta * 100).toFixed(1) + "pp",
      };
    });
  }
}
